module.exports = __webpack_public_path__ + "static/media/zoom-in.b99e7c6d.svg";